import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
    faAngleLeft,
    faAngleRight,
    faCheck,
    faFileExcel,
    faMagnifyingGlass,
    faPen,
    faPenToSquare,
    faSquareCheck,
    faSquarePlus,
    faSquareXmark,
    faTrash,
    faUpload,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
import {validateAllFormFields, formatOrganizationName} from '../../../common/utils';
import * as moment from 'moment-timezone';
import {
    SalesInstallationPartnerSelectComponent
} from '../../shared/sales-installation-partner-select/sales-installation-partner-select.component';
import {AuthService} from '../../services/auth.service';


@Component({
    selector: 'app-add-organization',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule, FormsModule, SalesInstallationPartnerSelectComponent],
    templateUrl: './add-organization.component.html',
    styleUrl: './add-organization.component.css'
})
export class AddOrganizationComponent {
  activeTab: string = 'addCustomer'; // Default active tab
  orgId:number = 0;
  isEditing: Boolean = false;
  role: string ='';
    isPlatformSuperuser = false;
  organizationForm!: FormGroup;
  addressTypes = [
      'Hotel',
      'Airport',
      'Home',
      'Appartment',
      'Office',
      'Mall',
      'Other',
    'Fleet Yard',

  ]
//   timeZones = {
//       "Asia/Kolkata": "India -  Asia/Kolkata",
//       "America/New_York": "USA (Eastern) - America/New_York",
//       "America/Chicago": "USA (Central) - America/Chicago",
//       "America/Denver": "USA (Mountain) - America/Denver",
//       "America/Los_Angeles": "USA (Pacific) - America/Los_Angeles",
//       "Europe/London": "UK - Europe/London",
//       "Asia/Kuala_Lumpur": "Malaysia - Asia/Kuala_Lumpur",
//       "Asia/Bangkok": "Thailand - Asia/Bangkok",
//       "Asia/Singapore": "Singapore - Asia/Singapore",

// }
  
  timezones = moment.tz.names();
  customerSources = [
    ['DIRECT', 'Direct'],
    ['INDIA_MART', 'IndiaMART'],
    ['WEBSITE', 'Website'],
    ['REFERENCE', 'Reference'],
    ['SALES_INSTALLATION_PARTNER', 'Sales & Installation Partner'],
    ['OTHER', 'Other'],
  ];
  installationOptions = [
    ['KYRA_TEAM', 'Kyra Team'],
    ['SALES_INSTALLATION_PARTNER', 'Sales & Installation Partner'],
    ['CUSTOMER_TEAM', 'Customer Team'],
    ['OTHER_VENDOR', 'Other Vendor'],
  ];
    demoDurations = [3, 7, 10, 15, 30];


  constructor(private apiService: ApiService,
              library: FaIconLibrary,
              private router: Router,
              private toastr:ToastrService,
              private fb: FormBuilder,
              private authService: AuthService) {

    library.addIcons(faTrash,
                    faFileExcel,
                    faAngleRight,
                    faAngleLeft,
                    faUpload,
                    faSquarePlus,
                    faMagnifyingGlass,
                    faPen,
                    faPenToSquare,
                    faXmark,
                    faCheck,
                    faSquareCheck,
                    faSquareXmark
                  );
    
    let user = localStorage.getItem('user');
    if (user){
      const userObj = JSON.parse(user)
      this.orgId = userObj['org_id']
      this.role = userObj['groups']
    }
      this.isPlatformSuperuser = this.authService.isSuperUser();

    const navigation = this.router.getCurrentNavigation();
    let staffTab = navigation?.extras.state?.['activeTab'];
    if (staffTab){
      this.activeTab = staffTab
    }


    this.organizationForm = this.fb.group({
      name: ['', Validators.required],
      pincode: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      locality: ['', Validators.required],
      flatBuildingName: ['', Validators.required],
      landmark: [''],
      addressType: ['', Validators.required],
      isDefault: [true, Validators.required],
      timezone: ['Asia/Kolkata', Validators.required],
      customer_source: [''],
      source_sales_installation_partner: [null],
      installation_by: [''],
      installation_sales_installation_partner: [null],
      is_demo_account: [false],
      demo_duration_days: [7]
    })
    this.setupPartnerFieldHandlers();

  }

  selectTab(tab: string): void {
    this.activeTab = tab;
  }

  

  onPincodeChange() {
    const pincode = this.organizationForm.get('pincode')?.value;

    if (pincode && pincode.length === 6) { // Adjust length validation based on your region
      this.fetchCityState(pincode);
    }
  }

  fetchCityState(pincode: number){
    this.apiService.getCityState(pincode).subscribe({
      next: (data: any) => {
        if (data.length > 0){
          data = data[0]
          this.organizationForm.patchValue({
            city: data.district_name,
            state: data.state_name,
            // locality: data.village_or_locality_name,
          });
        }
        
        
      },
      error: (err) => {
        if (err['error']['detail']) {
          this.toastr.error(err['error']['detail'], 'Error')
        }
      }
    });
  }

  onSubmit(){
    if (this.organizationForm.valid){
      let formData = new FormData();
        formData.append('name', formatOrganizationName(this.organizationForm.value.name))
      formData.append('address.pincode', this.organizationForm.value.pincode)
      formData.append('address.city', this.organizationForm.value.city)
      formData.append('address.state', this.organizationForm.value.state)
      formData.append('address.locality', this.organizationForm.value.locality)
      formData.append('address.flat_building_name', this.organizationForm.value.flatBuildingName)
      formData.append('address.landmark', this.organizationForm.value.landmark)
      formData.append('address.address_type', this.organizationForm.value.addressType)
      formData.append('address.is_default', this.organizationForm.value.isDefault)
      formData.append('timezone', this.organizationForm.value.timezone)
      formData.append('customer_source', this.organizationForm.value.customer_source || '')
      if (this.organizationForm.value.customer_source === 'SALES_INSTALLATION_PARTNER' && this.organizationForm.value.source_sales_installation_partner) {
        formData.append('source_sales_installation_partner', this.organizationForm.value.source_sales_installation_partner)
      }
      formData.append('installation_by', this.organizationForm.value.installation_by || '')
      if (this.organizationForm.value.installation_by === 'SALES_INSTALLATION_PARTNER' && this.organizationForm.value.installation_sales_installation_partner) {
        formData.append('installation_sales_installation_partner', this.organizationForm.value.installation_sales_installation_partner)
      }
      formData.append('is_demo_account', this.organizationForm.value.is_demo_account ? 'true' : 'false')
      if (this.organizationForm.value.is_demo_account) {
        formData.append('demo_duration_days', this.organizationForm.value.demo_duration_days)
      }
      formData.append('address.country', 'India')
      formData.append('is_active', "true")
      this.apiService.addOrganization(formData).subscribe({
        next: (res: any) => {
          this.toastr.success("New Customer Added Successfully", 'Success');
          this.router.navigate(['organization'], {state: {'activeTab': 'customer'}})
          
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['name']) {
            err['error']['name'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }

        }
      }) 

  }else{
    validateAllFormFields(this.organizationForm)
  }
  }
  
  onCancel() {
    this.router.navigate(['organization'], {state: {'activeTab': 'customer'}})

  }

  get showSourcePartnerField(): boolean {
    return this.organizationForm.get('customer_source')?.value === 'SALES_INSTALLATION_PARTNER';
  }

  get showInstallationPartnerField(): boolean {
    return this.organizationForm.get('installation_by')?.value === 'SALES_INSTALLATION_PARTNER';
  }

  setSourcePartner(partnerId: number | null): void {
    const control = this.organizationForm.get('source_sales_installation_partner');
    control?.setValue(partnerId);
    control?.markAsDirty();
    control?.markAsTouched();
  }

  setInstallationPartner(partnerId: number | null): void {
    const control = this.organizationForm.get('installation_sales_installation_partner');
    control?.setValue(partnerId);
    control?.markAsDirty();
    control?.markAsTouched();
  }

  private setupPartnerFieldHandlers(): void {
    this.organizationForm.get('customer_source')?.valueChanges.subscribe((value) => {
      if (value !== 'SALES_INSTALLATION_PARTNER' && this.organizationForm.get('source_sales_installation_partner')?.value) {
        this.organizationForm.patchValue({ source_sales_installation_partner: null }, { emitEvent: false });
      }
    });

    this.organizationForm.get('installation_by')?.valueChanges.subscribe((value) => {
      if (value !== 'SALES_INSTALLATION_PARTNER' && this.organizationForm.get('installation_sales_installation_partner')?.value) {
        this.organizationForm.patchValue({ installation_sales_installation_partner: null }, { emitEvent: false });
      }
    });
  }
}
